import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from 'vue-axios'
import Vuex from 'vuex'
import store from "./store";
import 'es6-promise/auto'
import Affix from 'vue-affix';
import VueCookies from 'vue-cookies'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'
import VueSimpleAlert from "vue-simple-alert";
import AnimatedCss from 'animate.css';
import VueLazyload from 'vue-lazyload';
import Clipboard from 'v-clipboard';
import Vuelidate from 'vuelidate';
import VModal from 'vue-js-modal'

Vue.use(VModal)
Vue.use(Vuelidate)
Vue.use(Clipboard)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'static/assets/images/img_load.gif',
  attempt: 1
})

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
Vue.use(VueCookies)
Vue.use(AnimatedCss);

    
Vue.use(VueAxios, axios)
Vue.use(Affix);
Vue.use(Vuex)
Vue.use(VueSimpleAlert);
Vue.$cookies.config('7d');
import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js